import { baseState, baseMutations } from '@/store/mixins'
import httpClient from '@/http-client'
import moment from 'moment'

const BASE_URL = '/api/payment-notices'

export default {
  namespaced: true,
  state: {
    ...baseState,
    show_data: {},
    date_from: moment().format('DD-MM-YYYY'),
    date_to: moment().format('DD-MM-YYYY'),
    selectedStudent: {},
    loading: false,
    showStudentModel: false,
    academicTerms: []
  },
  mutations: {
    ...baseMutations,
    SET_DATE_FROM(state, date) {
      state.date_from = date
    },
    SET_DATE_TO(state, date) {
      state.date_to = date
    },
    SET_SELECTED_STUDENT(state, student) {
      state.selectedStudent = student
    },
    SET_LOADING(state, value) {
      state.loading = value
    },
    HIDE_SHOW_STUDENT_MODEL(state, value) {
      state.showStudentModel = value
    },
    SET_TERM_LIST(state, value){
      state.academicTerms = value
    }
  },
  actions: {
    onGetStudent(context, params = {}) {
      return httpClient.get(`${BASE_URL}/students`, {
        params
      })
    },
    onGetLevel(context, params = {}) {
      return httpClient.get(`${BASE_URL}/levels`, {
        params
      })
    },
    onGetGradeByLevel(context, params = {}) {
      return httpClient.get(`${BASE_URL}/grade-by-levels`, {
        params
      })
    },
    onGetFeeSetup(context, params = {}) {
      return httpClient.get(`${BASE_URL}/fee-setups`, {
        params
      })
    },
    onGetFeeType(context, params = {}) {
      return httpClient.get(`${BASE_URL}/fee-types`, {
        params
      })
    },
    onGetStudentFeeDetail(context, params = {}) {
      return httpClient.get(`${BASE_URL}/student-fee-details`, {
        params
      })
    },
    onGetSubprogram(context, params = {}) {
      return httpClient.get(`${BASE_URL}/subprograms`, {
        params
      })
    },
    onGetGrade(context, params = {}) {
      return httpClient.get(`${BASE_URL}/grades`, {
        params
      })
    },
    onGetStudyTime(context, params = {}) {
      return httpClient.get(`${BASE_URL}/study-times`, {
        params
      })
    },
    onGetTerm(context, params = {}) {
      return httpClient.get(`${BASE_URL}/terms`, {
        params
      })
    },
    onPreviewPdf(context, { id }) {
      return httpClient.get(`${BASE_URL}/${id}/preview-pdfs`)
    },
    onGetBank(context, params = {}) {
      return httpClient.get(`${BASE_URL}/banks`, {
        params
      })
    },
    onFetch(context, attrubutes = {}) {
      let params = Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attrubutes
      )
      return httpClient.get(`${BASE_URL}`, {
        params
      })
    },

    onSaveNewStudent(context, data) {
      return httpClient.post(`${BASE_URL}/new-students`, data)
    },
    onSave(context, data) {
      return httpClient.post(`${BASE_URL}`, data)
    },
    onUpdate(context, { data, id }) {
      return httpClient.put(`${BASE_URL}/${id}`, data)
    },
    onApprove(context, data) {
      return httpClient.post(`${BASE_URL}/${data.inv_id}/approves`, {
        data
      })
    },
    onDeleteRecord(context, params = {}) {
      return httpClient.get(`${BASE_URL}/deletes`, {
        params
      })
    },
    onShowRecord(context, id) {
      let response = httpClient.get(`${BASE_URL}/${id}/shows`)
      return response
    },
    async onFindInvoice(context, id) {
      let response = await httpClient.get(`${BASE_URL}/${id}/invoice`)
      context.commit('SET_EDIT_DATA', response.data.data)
      return response
    },
    onCheckStudentHasPreInvoice(context, params = {}) {
      return httpClient.get(`${BASE_URL}/check-student-has-pre-invoices`, {
        params
      })
    }
  }
}
